<template>
  <div>
    <div v-if="grados.length" class="tabla-scroll">
      <table class="tabla-rubrica">
        <thead>
          <tr>
            <th>GRADO DE VALORACIÓN</th>
            <th>GRADO DE CUMPLIMIENTO</th>
            <th>VALORACIÓN</th>
            <th class="col-escala">ESCALA CUANTITATIVA</th>
            <th class="col-escala">CUMPLIMIENTO %</th>
            <th>JUICIO DE VALOR</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(g, i) in grados" :key="i">
            <td class="celda-grado">{{ g.grado_valoracion || '—' }}</td>
            <td class="celda-grado">{{ g.grado }}</td>
            <td class="celda-centro">{{ g.valoracion || '—' }}</td>
            <td class="celda-escala">{{ formatoRango(g.rango_min, g.rango_max) }}</td>
            <td class="celda-escala">{{ formatoPct(g.pct_min, g.pct_max) }}</td>
            <td class="celda-juicio">{{ g.juicio_de_valor || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="vacio">Esta rúbrica no tiene tabla de valoración.</p>
  </div>
</template>

<script lang="ts" setup>
/**
 * Editor de la rúbrica de opinión.
 *
 * Las opciones que ofrece una pregunta salen de esta tabla: una etiqueta fuera de
 * ella no puntúa en la conversión a nota.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { computed } from 'vue'
import type { RubricaCriterio, RubricaOpinion, GradoValoracionOpinion } from '@/interfaces/CriterioEvaluacion'
import { esRubricaOpinion } from '@/interfaces/CriterioEvaluacion'

const props = defineProps<{ rubrica: RubricaCriterio | null | undefined }>()

const grados = computed<GradoValoracionOpinion[]>(() => {
  const r = props.rubrica
  if (!r || !esRubricaOpinion(r)) return []
  return (r as RubricaOpinion).grados ?? []
})

function formatoRango(min?: number, max?: number): string {
  if (min == null || max == null) return '—'
  return `${formatoNumero(min)} a ${formatoNumero(max)}`
}

function formatoPct(min?: number | null, max?: number | null): string {
  if (min == null || max == null) return '—'
  return `${min} a ${max}`
}

function formatoNumero(v: number): string {
  return Number.isInteger(v) ? v.toFixed(1) : String(v)
}
</script>

<style scoped>
.tabla-scroll {
  overflow-x: auto;
}

.tabla-rubrica {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem;
}

.tabla-rubrica th {
  background: #5b9bd5;
  color: #fff;
  font-weight: 700;
  text-align: center;
  padding: 0.55rem 0.6rem;
  border: 1px solid #b8cce4;
  white-space: nowrap;
}

.tabla-rubrica td {
  border: 1px solid #b8cce4;
  padding: 0.5rem 0.6rem;
  vertical-align: middle;
  color: #222;
}

.tabla-rubrica tbody tr:nth-child(odd) {
  background: #deeaf6;
}

.tabla-rubrica tbody tr:nth-child(even) {
  background: #fff;
}

.celda-grado {
  font-weight: 700;
  white-space: nowrap;
}

.celda-centro {
  text-align: center;
  font-weight: 600;
}

.celda-escala {
  text-align: center;
  white-space: nowrap;
}

.celda-juicio {
  min-width: 320px;
  text-align: justify;
}

.col-escala {
  min-width: 110px;
}

.vacio {
  margin: 0;
  color: #888;
  font-size: 0.85rem;
}
</style>
